import { render, staticRenderFns } from "./TrainerObservation.vue?vue&type=template&id=5b5de09e&scoped=true&"
import script from "./TrainerObservation.vue?vue&type=script&lang=js&"
export * from "./TrainerObservation.vue?vue&type=script&lang=js&"
import style0 from "./TrainerObservation.vue?vue&type=style&index=0&id=5b5de09e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5de09e",
  null
  
)

export default component.exports